export const getCurrentMonthAndYear = () => {
  const date = new Date()
  return date.toLocaleString("en", { month: "long", year: "2-digit" })
}
